export enum AppCategory {
  TRAVPRO_MOBILE = 1,
  NORTH_AMERICA = 4,
  EUROPE = 5,
  LATIN_AMERICA = 6,
  ASIA_AND_PACIFIC = 7,
  DOMESTIC_DESTINATIONS = 9,
  CALIFORNIA_MODULES = 10,
  LAS_VEGAS_MODULES = 11,
  INTERNATIONAL_DESTINATIONS = 12,
  TOUR_OPERATORS = 13,
  CRUISE_LINES = 14,
  ACCOMMODATIONS = 15,
  RAIL_AND_TRANSPORT = 16,
  FEATURED = 19,
  DOMESTIC_MODULES = 22,
  CANADA_MODULES = 24,
  PARTNERS = 25,
  COMING_SOON = 26,
  CANADA_CITY_MODULES = 28,
  RECENTLY_LAUNCHED = 29,
}
